import {
  CardBody,
  Company,
  DefaultValueProps,
  DetailProgram,
  HeaderImage,
  PriceComponent,
} from "@components/shared-components/Card/CardProgram"
import { capitalize } from "lib/helpers"
import Divider from "lib/components/Divider"
import { gtmEcommerce } from "lib/gtm"
import { useRouter } from "next/router"

function CardRelatedBlog({
  sectionName,
  index,
  id,
  programName,
  category,
  finalRating,
  finalRatingParticipants,
  slug,
  programThumbnailUrl,
  type,
  tpName,
  tpProfileUrl,
  discountPrice,
  discount,
  classEndDate,
  price,
  classCode,
  classStartDate,
  customImage,
}: DefaultValueProps) {
  const router = useRouter()
  return (
    <div
      role="button"
      tabIndex={index}
      className="flex flex-col mb-2 mx-2 gap-4 overflow-hidden rounded-md hover:cursor-pointer h-card border"
      onClick={async () => {
        localStorage.setItem("selectedIndexItem", (index + 1).toString())
        localStorage.setItem("sectionName", sectionName)
        await gtmEcommerce({ ecommerce: null })
        await gtmEcommerce({
          event: "select_item",
          ecommerce: {
            value: discountPrice,
            items: [
              {
                item_list_id: sectionName.toLowerCase().replace(/ /g, "-"), // adjust to section id
                item_list_name: sectionName, // adjust to section name
                item_id: id, // adjust to item id
                item_name: programName, // adjust to item name
                item_brand: tpName, // adjust to item brand
                item_category: capitalize(category.slug, "-"), // adjust to item category
                item_variant: `${capitalize(type)} Program`, // or Public Program, Bootcamp Program
                index: index + 1, // adjust to the promotion index/slot
                currency: "IDR",
                price,
                discount: Math.round(price * (discount / 100)),
                quantity: 1,
              },
            ],
          },
        })
        await router.push(
          `/${category.slug}/${type}/${slug}/${
            type !== "inhouse" && type !== "prakerja" ? classCode : ""
          }`,
        )
      }}>
      {/* header */}
      <HeaderImage
        category={{
          description: category.description,
          name: category.name,
        }}
        programThumbnailUrl={customImage || programThumbnailUrl}
        programName={programName}
        type={type}
        customClass="col-span-1"
        index={index}
      />
      {/* header */}

      {/* Header Title */}
      <CardBody customClass="col-span-2 px-4">
        <DetailProgram
          category={{
            description: category.description,
            name: category.name,
          }}
          classEndDate={classEndDate}
          classStartDate={classStartDate}
          programName={programName}
          type={type}
        />
        {/* Header Title */}
        <div className="hidden lg:block">
          <PriceComponent discount={discount} discountPrice={discountPrice} price={price} />
          <Company
            finalRating={finalRating}
            finalRatingParticipants={finalRatingParticipants}
            tpName={tpName}
            tpProfileUrl={tpProfileUrl}
          />
        </div>
        <div className="block lg:hidden">
          <Company
            finalRating={finalRating}
            finalRatingParticipants={finalRatingParticipants}
            tpName={tpName}
            tpProfileUrl={tpProfileUrl}
          />
          <Divider customClass="my-0 border-t-0 border-gray-300 hidden lg:block" />
          <PriceComponent discount={discount} discountPrice={discountPrice} price={price} />
        </div>

        {/* price */}
      </CardBody>

      {/* body */}
    </div>
  )
}

export default CardRelatedBlog
